import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // bail if no headlines
    if (!this.element) return

    // animation timing constants
    this.animationDelay       = 4400     // delay between word swaps

    this.initHeadline()
  }

  disconnect() {
    // clear any pending timers if you care about cleanup
    if (this._timeout) clearTimeout(this._timeout)
  }

  initHeadline() {
    this.animateHeadline()
  }

  animateHeadline() {
    // start the loop
    this._timeout = setTimeout(() => {
      const current = this.element.querySelector(".is-visible")
      this.hideWord(current)
    }, this.animationDelay)
  }

  hideWord(oldWord) {
    const nextWord = this.takeNext(oldWord)
    this.switchWord(oldWord, nextWord)
    // queue next swap
    this._timeout = setTimeout(() => {
      this.hideWord(nextWord)
    }, this.animationDelay)
  }

  takeNext(word) {
    const siblings = Array.from(this.element.children)
    const idx = siblings.indexOf(word)
    return siblings[(idx + 1) % siblings.length]
  }

  switchWord(oldWord, newWord) {
    oldWord.classList.remove("is-visible")
    oldWord.classList.add("is-hidden")
    newWord.classList.remove("is-hidden")
    newWord.classList.add("is-visible")
  }
}
